import {
  ToggleFilterChip,
  createToggleFilter,
} from '@spotify/confidence-core-react';

export const CAN_EDIT_FILTER_ID = 'canEdit';

export const CAN_EDIT_DESCRIPTION =
  'Experiments you can edit through ownership, shared permissions, or surface admin access.';

export const CAN_EDIT_FILTER = createToggleFilter({
  id: CAN_EDIT_FILTER_ID,
  label: 'Editable by me',
  description: CAN_EDIT_DESCRIPTION,
  query: () => '',
  viewer: ToggleFilterChip,
});
